import React, { useMemo } from "react";
import { Modal, Steps } from "antd";
import { MarketingApproval, approvalProcessStatusEnum } from "../allMemberMarketingListTypes";


const { Step } = Steps;

interface AuditRecordDrawerProps {
	visible: boolean;
	onClose: () => void;
	auditInstanceList?: MarketingApproval[];
}

export function AuditRecordDrawer({ visible, onClose, auditInstanceList = [] }: AuditRecordDrawerProps) {
	const records = useMemo(() => {
		if (!auditInstanceList || auditInstanceList.length === 0) {
			return [];
		}

		let list = [...auditInstanceList].sort((a, b) => {
			const versionA = Number(a?.version ?? 0) || 0;
			const versionB = Number(b?.version ?? 0) || 0;
			if (versionA !== versionB) {
				return versionA - versionB;
			}
			const orderNumA = Number(a?.orderNum ?? 0) || 0;
			const orderNumB = Number(b?.orderNum ?? 0) || 0;
			return orderNumA - orderNumB;
		});

		let maxVersion = 0;
		if (list.length > 0) {
			maxVersion = Number(list[list.length - 1]?.version ?? 0) || 0;
		}

		let records: any[] = [];
		let stepCurrent = 0;
		let maxVersionHasRejected = false;

		list.forEach((item) => {
			const { version, status, approverName, name, processTime, rejectReason, opinion } = item;

			if (version < maxVersion && status === approvalProcessStatusEnum.approvalProcessStatusUnapproved) {
				return;
			}

			if (version === maxVersion && status === approvalProcessStatusEnum.approvalProcessStatusDenied) {
				maxVersionHasRejected = true;
			}

			if (version === maxVersion && status === approvalProcessStatusEnum.approvalProcessStatusUnapproved && maxVersionHasRejected) {
				return;
			}

			if (status !== approvalProcessStatusEnum.approvalProcessStatusUnapproved) {
				stepCurrent++;
			}

			let statusName = "";
			let statusClassName = "";
			let stepStatus: "finish" | "process" | "wait" | "error" = "wait";

			if (status === approvalProcessStatusEnum.approvalProcessStatusDenied) {
				statusName = "已驳回";
				statusClassName = "error";
				stepStatus = "error";
			} else if (status === approvalProcessStatusEnum.approvalProcessStatusApproved) {
				statusName = "已通过";
				statusClassName = "success";
				stepStatus = "finish";
			} else if (status === approvalProcessStatusEnum.approvalProcessStatusUnapproved) {
				statusName = "待审核";
				statusClassName = "wait";
				stepStatus = "process";
			} else if (status === approvalProcessStatusEnum.approvalProcessStatusSubmitted) {
				statusName = "发起审核";
				statusClassName = "success";
				stepStatus = "finish";
			}

			records.push({
				...item,
				statusName,
				statusClassName,
				stepStatus,
			});
		});

		return records;
	}, [auditInstanceList]);

	return (
		<Modal
			title="审批记录"
			visible={visible}
			onCancel={onClose}
			footer={null}
			width={600}
		>
			{records.length === 0 ? (
				<div style={{ textAlign: "center", color: "#999", padding: "40px" }}>
					暂无审批记录
				</div>
			) : (
				<Steps direction="vertical" current={records.findIndex(r => r.stepStatus === "process")}>
					{records.map((item, index) => (
						<Step
							key={index}
							status={item.stepStatus}
							title={
								<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
									<span>{item.name}</span>
									<span style={{ fontSize: "12px", color: "#909399", marginLeft: "10px" }}>
										{item.processTime}
									</span>
								</div>
							}
							description={
								<div>
									<div style={{ fontSize: "14px", color: "#909399", marginTop: "8px" }}>
										{item.approverName}
										<span style={{ marginLeft: "8px", color: item.statusClassName === "error" ? "#fa3534" : item.statusClassName === "success" ? "#3c9cff" : "#909399" }}>
											{item.statusName}
										</span>，
									</div>
									{item.rejectReason && item.status === approvalProcessStatusEnum.approvalProcessStatusDenied && (
										<div style={{ fontSize: "14px", color: "#fa3534", marginTop: "4px" }}>
											驳回原因: {item.rejectReason}
										</div>
									)}
									{item.opinion && item.status === approvalProcessStatusEnum.approvalProcessStatusApproved && (
										<div style={{ fontSize: "14px", color: "#666", marginTop: "4px" }}>
											审批意见: {item.opinion}
										</div>
									)}
								</div>
							}
						/>
					))}
				</Steps>
			)}
		</Modal>
	);
}
